<div class="offcanvas-content pr-5 mr-n5 activities-assign-panel">
    <div class="d-flex justify-content-between align-items-center mb-5">
        <div class="d-flex">
            <div class="panel-nav_icon d-inline-flex">
                <button class="btn"
                        style="padding-left: 0;"
                        (click)="closePanel()">
                    <i class="fa fa-arrow-left"></i>
                </button>
            </div>
            <div class="panel-nav_title d-inline-flex align-self-center">
                {{ l('Assign') }}
            </div>
        </div>
        
        <div class="d-flex">
            <!-- For future use -->
            
            <!--<button class="btn"
                    (click)="creatorSelector.open()"
                    data-toggle="select-days-modal"
                    [disabled]="(activityData.activitySourceDetails
                    && !activityData.activitySourceDetails.multipleActivityDaysCreationAllowed)
                    || !isGranted('Pages.ActivityDays.Edit')"
                    >
                    <i class="fas fa-layer-group"></i>
            </button>
             <div class="mr-3 mb-3">
                <div class="activitycopySection">
                    <mat-form-field>
                        <mat-select
                            [formControl]="creatorFormCtrl"
                            #creatorSelector
                            multiple
                        >
                        <div style="max-height: 150px;overflow-y: scroll;">
                            <mat-option>
                                <ngx-mat-select-search
                                    noEntriesFoundLabel="No results found"
                                    placeholderLabel="Search an activity..."
                                    [formControl]="creatorFilterFormCtrl"
                                >
                                </ngx-mat-select-search>
                            </mat-option>
                            
                            <mat-option
                                *ngFor="let creator of activityList"
                                [value]="creator"

                                (click)="updateSelectedActivity(creator)"
                            >
                                {{ creator.activityId }}      
                                {{ creator.activityName }}      
                                {{ activityData.activityDay | momentFormat:'DD/MM/YY'}}
                            </mat-option>
                        </div>
                            <div class="input-group-append Width100 colorbox">
                                <button class="btn btn-primary blue Width100 margin"  type="button" (click)="copyActivitybyActivityId()">
                                    {{ l("Apply") }}
                                </button>
                            </div>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div> -->
            <!-- <button class="btn"
                    data-toggle="select-days-modal"
                    [disabled]="(activityData.activitySourceDetails
                    && !activityData.activitySourceDetails.multipleActivityDaysCreationAllowed)
                    || !isGranted('Pages.ActivityDays.Edit')"
                    (click)="cloneActivity(activityData.activityId, activityData.activityDayId)">
                <i class="fa fa-copy"></i>
            </button> -->
            
            <div class="btn-group dropdown"
                 dropdown
                 [ngClass]="{'disabled': !isGranted('Pages.ActivityDays.Edit')}">
                <button class="dropdown-toggle btn btn-sm"
                        [ngClass]="{'disabled': !isGranted('Pages.ActivityDays.Edit')}"
                        dropdownToggle
                        [disabled]="(!activityData.isSubmitted
                        && activityData.activitySourceDetails
                        && !activityData.activitySourceDetails.multipleActivityDaysCreationAllowed)
                        || !isGranted('Pages.ActivityDays.Edit')"
                        *ngIf="isGranted('Pages.Activities.Create')">
                        <i class="fa fa-copy"></i>
                </button>
                <ul class="dropdown-menu"
                    *dropdownMenu
                    style="margin-left: -60px">
                    <!-- <li *ngIf="!activityData.isSubmitted"> -->
                        <li *ngIf="activityData.activitySourceDetails?.multipleActivityDaysCreationAllowed">
                        <button class="dropdown-item"
                        (click)="cloneActivity(activityData.activityId, activityData.activityDayId,false)">
                            <span >{{ l('CloneNameOnly') }}</span>
                        </button>
                    </li>
                    <li *ngIf="activityData.activitySourceDetails?.multipleActivityDaysCreationAllowed">
                        <button
                            [disabled]="!isGranted('Pages.ActivityDays.Delete')"
                            (click)="cloneActivity(activityData.activityId, activityData.activityDayId,true)"
                            class="dropdown-item">
                            <span >{{ l('CloneWithData') }}</span>
                        </button>
                    </li>
                </ul>
            </div>
            <div class="btn-group dropdown"
                 dropdown
                 [ngClass]="{'disabled': !isGranted('Pages.ActivityDays.Delete')}">
                <button class="dropdown-toggle btn btn-sm"
                        [ngClass]="{'disabled': !isGranted('Pages.ActivityDays.Delete')}"
                        dropdownToggle
                        [disabled]="(!activityData.isSubmitted
                        && activityData.activitySourceDetails
                        && !activityData.activitySourceDetails.multipleActivityDaysCreationAllowed)
                        || !isGranted('Pages.ActivityDays.Edit')"
                        *ngIf="allocationSheetStatus == allocationSheetStatusNotSubmitted">
                    <i class="fa fa-trash"></i>
                </button>
                <ul class="dropdown-menu"
                    *dropdownMenu
                    style="margin-left: -60px">
                    <li *ngIf="!activityData.isSubmitted">
                        <button class="dropdown-item"
                                (click)="deleteDay(activityData.activityDayId)">
                            <span >{{ l('Day') }}</span>
                        </button>
                    </li>
                    <li *ngIf="activityData.activitySourceDetails?.multipleActivityDaysCreationAllowed">
                        <button
                            [disabled]="!isGranted('Pages.ActivityDays.Delete')"
                            (click)="deleteNotSubmittedDays(activityData.activityId)"
                            class="dropdown-item">
                            {{ l('AllDays') }}
                        </button>
                    </li>
                </ul>
            </div>

        </div>
    </div>

    <div class="navi navi-spacer-x-0 p-0">
        <div class="row">
            <div class="col-md-7">
                <div class="form-group">
                    <label class="bold"
                           for="activityNameInput">{{l("ActivityName")}}
                        <button class="btn btn-sm d-inline-block"
                                (click)="setActivityNameEdit()"
                                [disabled]="!activityData.activitySourceDetails?.isActivityNameEditable
                                || activityData.isSubmitted || !isGranted('Pages.ActivityDays.Edit')">
                            <i class="fa fa-edit"></i>
                        </button>
                    </label>

                    <input *ngIf="activityNameEdit; else activityNameDisplay"
                           class="form-control activiyname-edit"
                           id="activityNameInput"
                           [disabled]="!activityData.activitySourceDetails?.isActivityNameEditable || !isGranted('Pages.ActivityDays.Edit')"
                           [(ngModel)]="activityData.name"
                           (blur)="updateActivityName(activityData.name, activityData.activityDayId)">
                    <ng-template #activityNameDisplay>
                                <span class="d-block"
                                      style="padding: 0.72rem 0.72rem 0.72rem 0">{{ activityData.name }}</span>
                    </ng-template>
                </div>
            </div>
            <div class="col-md-5">
                <label class="bold">{{ l('Creator') }}</label>
                <button class="btn btn-default d-block custom-disabled"
                        [disabled]="true">
                    {{ activityData.creatorDetails ? activityData.creatorDetails.firstName +
                    ' ' + activityData.creatorDetails.lastName : 'Allo admin' }}
                </button>
            </div>


            <div class="col-md-6">
                <label class="bold">{{ l('ActivityDay') }}</label>
                <span class="d-block coloured">
                    {{ activityData.activityWorkDay | momentFormat:'DD/MM/YY' }}
                </span>
            </div>

            <div class="col-md-6">
                <label class="bold">{{ l('AssignedSupervisor') }}</label>
                <span class="d-block coloured">
                    {{ activityData.assignedStaffDetails.firstName }}
                    {{ activityData.assignedStaffDetails.lastName }}
                </span>
            </div>

            <div class="col-md-6 margin-top-15">
                <app-assign-assets
                    [controlDisabled]="
                    isGranted('Pages.Role.Admin') ? false 
                    : (activityData.isSubmitted || !isGranted('Pages.ActivityDays.Edit') 
                    || (!activityData.isSubmitted && !isGranted('Pages.Activities.Create')))
                    "
                    [assetsToBeAssigned]="assetsToBeAssigned"
                    [activityDayId]="activityData.activityDayId"
                    [assetCode]="activityData.assetCode"
                    [controllingStructureCode]="activityData.controllingStructureCode"
                    (onAssignedCounterUpdate)="updateControllerCounter($event)"
                    >
                </app-assign-assets>
            </div>

            <div class="col-md-6 margin-top-15"
                 *ngIf="activityData.activitySourceDetails.isWorkPlanExecutionEditable">
                <label class="bold">{{ l('VarianceFromPlanReason') }}</label>
                <app-variance-from-plan
                    [controlDisabled]="
                    activityData.isSubmitted 
                    || !isGranted('Pages.ActivityDays.Edit') 
                    || (!activityData.isSubmitted && !isGranted('Pages.Activities.Create'))
                    "
                    [variancesFromPlanReasons]="variancesFromPlanReasons"
                    [workPlanExecution]="activityData.workPlanExecution"
                    [activityDayId]="activityData.activityDayId"
                    (onVarianceUpdated)="updateVercinnceCounter($event)"
                    >
                </app-variance-from-plan>
            </div>

            <div class="col-md-12  margin-top-15">
                <label class="bold">{{ l('AssignPersonnel') }} </label>
                <app-assign-personal-table
                    [controlDisabled]="this.GetControlDisabledForPlantPersonalAndMatiral(activityData.isSubmitted)"
                    [allowedPersonnel]="allowedPersonnel"
                    [allocatedPersonnel]="activityData.allocatedPersonnel"
                    [activityDayId]="activityData.activityDayId"
                    (onAssignedCounterUpdate)="updatePersonnelCounter($event)"
                    [anyResourceSelected]="plantsTotal>0 || personnelTotal>0 || materialsTotal>0"
                    >
                </app-assign-personal-table>
            </div>

            <div class="col-md-12  margin-top-15">
                <label class="bold">{{ l('AssignPlants') }} </label>
                <app-assign-plants-table
                [controlDisabled]="this.GetControlDisabledForPlantPersonalAndMatiral(activityData.isSubmitted)"
                    [allowedPlants]="allowedPlants"
                    [allocatedPlants]="activityData.allocatedPlants"
                    [activityDayId]="activityData.activityDayId"
                    (onAssignedCounterUpdate)="updatePlantCounter($event)"
                    [anyResourceSelected]="plantsTotal>0 || personnelTotal>0 || materialsTotal>0"
                    ></app-assign-plants-table>
            </div>

            <div class="col-md-12  margin-top-15">
                <label class="bold">{{ l('AssignMaterial') }} </label>
                <app-assign-materials-table
                [controlDisabled]="this.GetControlDisabledForPlantPersonalAndMatiral(activityData.isSubmitted)"
                    [allowedMaterials]="allowedMaterials"
                    [allocatedMaterials]="activityData.allocatedMaterials"
                    [activityDayId]="activityData.activityDayId"
                    (onAssignedCounterUpdate)="updateMaterialCounter($event)"
                    [anyResourceSelected]="plantsTotal>0 || personnelTotal>0 || materialsTotal>0"
                    ></app-assign-materials-table>
            </div>
        </div>

    </div>
</div>

